module.exports = __webpack_public_path__ + "static/media/createAcct.98561267.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/docs/assets/createAcct.PNG
// module id = 259
// module chunks = 0